require("url-search-params-polyfill");

const loginForms = document.querySelectorAll(".js-login-redirect");
const loginRedirects = document.querySelectorAll(`[href="/account/login"]`);
const loginPractitioner = document.querySelectorAll("a.js-append-return-to");
//
// Clicking 'log in', in the header nav, or a random button?
//
// Add current URL as a redirect query string to any login buttons
// Which the login page can hook into
loginRedirects &&
  loginRedirects.forEach(r => {
    r.href += `?redirect=${encodeURIComponent(window.location.pathname)}`;
  });

//
// 'Log in' page
//
loginForms &&
  // Multiple forms potentially, e.g. within mobile nav (since removed)
  loginForms.forEach(f => {
    let redirect = document.createElement("input");
    redirect.type = "hidden";
    redirect.name = "checkout_url";
    //
    // On /account/login after clicking a login link?
    //
    // If it has a sweet redirect query string, use that as the redirect target
    const urlParams = new URLSearchParams(window.location.search);
    const redirectParam = urlParams.get("redirect");
    if (redirectParam) {
      redirect.value = redirectParam;
    }
    //
    // On a restricted page, with the 'Log in' message?
    //
    // Take the current URL as the redirect target
    else if (window.location && window.location.pathname) {
      redirect.value = window.location.pathname;
    }
    // Pump our hidden input it into the login form - telling shopify to redirect after submit
    f.prepend(redirect);
  });

// Multipass - let's add return parameters to the practitioner login link
loginPractitioner &&
  loginPractitioner.forEach(l => {
    l.href +=
      window.location.pathname == "/"
        ? ""
        : `&returnTo=${encodeURIComponent(window.location.pathname)}`;
  });
